module.exports = __webpack_public_path__ + "static/media/non-photo.d826c856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/non-photo.png
// module id = 1504
// module chunks = 0